import moment from 'moment'

export default {
  methods: {
    /**
     * Format Validity Presentation
     * @param {Array} - validity
     */
    formatValidityPresentation (validity) {
      if (validity.length === 0) {
        return 'NONE'
      }

      if (validity.length >= 2) {
        const startDate = moment(validity[0])
        const endDate = moment(validity[1])

        const isTheSameMonth = startDate.format('MM') === endDate.format('MM')
        const isTheSameYear = startDate.format('YYYY') === endDate.format('YYYY')
        const isTheSameDate = startDate.format('MM D YYYY') === endDate.format('MM D YYYY')

        // 2 dates are in the same month: 8-20 Aug 2018 (not 08-20)
        if (isTheSameMonth && isTheSameYear && !isTheSameDate) {
          return `${startDate.format('D')}-${endDate.format('D')} ${startDate.format('MMM')} ${startDate.format('YYYY')}`
        }

        // 2 dates are in the same month: 8-20 Aug 2018 (not 08-20)
        if (!isTheSameMonth && isTheSameYear) {
          return `${startDate.format('D')} ${startDate.format('MMM')}
            - ${endDate.format('D')} ${endDate.format('MMM')}
            ${startDate.format('YYYY')}`
        }

        // 2 date are in different year: 8 Aug 2018 - 20 Jan 2019
        if (!isTheSameYear) {
          return `${startDate.format('D')} ${startDate.format('MMM')} ${startDate.format('YYYY')}
            - ${endDate.format('D')} ${endDate.format('MMM')} ${endDate.format('YYYY')}`
        }

        // 2 date are the same month day and year
        if (isTheSameDate) {
          return `${startDate.format('D')} ${startDate.format('MMM')} ${startDate.format('YYYY')}`
        }
      }
    }
  }
}
